<template>
     <BaseContainer class="dnnCloud-UrlsNumber-box" :loading="listLoading" :isHasPageFt="!listLoading">
        <template v-slot:hd>
           <el-col :span="24" class="toolbar">
            <el-form>
              <el-form-item>
                <el-button type="primary" size="medium" @click="handleURLAdd" class="adds">新增</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </template>

        <template v-slot:main>
            <el-table  :data="urlList" highlight-current-row   style="width: 100%;" >
              <el-table-column type="index"  label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(pageNumber1 - 1) * pageSize1 + scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cloudserviceurl" label="路径" min-width="200" >
              </el-table-column>
              <el-table-column prop="version" label="版本" min-width="140" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="comment" label="备注" min-width="240" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" min-width="220" style="text-algin:center">
                <template slot-scope="scope">
                  <span class="operate">
                    <el-tooltip effect="dark" content="编辑" placement="top" >
                      <span class="dnnfont iconEdit"   @click="handleURLEdit(scope.$index, scope.row)"></span>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                        <span class="dnnfont icondelete"  @click="handleURLDel(scope.$index, scope.row)"></span>
                    </el-tooltip>
                 </span>
                  <!-- <el-button type="primary"  plain size="small" @click="handleURLEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="danger"  plain size="small" @click="handleURLDel(scope.$index, scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
              
            <!--新增url界面-->
            <el-dialog class="model-edit" title="新增" :visible.sync="addUrlVisible" :close-on-click-modal="false">
              <el-form :model="addUrl" label-width="80px" :rules="addUrlRules" ref="addForm">
                <el-row>
                  <el-col :span="22"> 
                    <el-form-item label="路径" prop="cloudserviceurl">
                      <el-input  v-model="addUrl.cloudserviceurl" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="版本" prop="version">
                      <el-input  v-model="addUrl.version" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="备注" prop="comment">
                      <el-input type="textarea" :rows="3" v-model="addUrl.comment" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button @click.native="addUrlVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addUrlSubmit" :loading="addUrlLoading">提交</el-button>
              </div>
            </el-dialog>
            <!--编辑url界面-->
            <el-dialog class="model-edit" title="编辑" :visible.sync="editUrlVisible" :close-on-click-modal="false">
              <el-form :model="editUrl" label-width="80px" :rules="editUrlRules" ref="addForm">
                <el-row>
                  <el-col :span="22"> 
                    <el-form-item label="路径" prop="cloudserviceurl">
                      <el-input  v-model="editUrl.cloudserviceurl" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="版本" prop="version">
                      <el-input  v-model="editUrl.version" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="备注" prop="comment">
                      <el-input type="textarea" :rows="3" v-model="editUrl.comment" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button @click.native="editUrlVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editUrlSubmit" :loading="editUrlLoading">提交</el-button>
              </div>
            </el-dialog>
        </template>

        <template v-slot:ft>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
              <el-pagination 
                layout="sizes, prev, pager, next"
                :page-sizes="[10, 20, 30, 50,100]"
                :current-page="pageNumber1" 
                @current-change="handleCurrentChange1" 
                @size-change="handleSizeChange1"
                :page-size="pageSize1"
                :total="total1" 
                style="float:right;">
              </el-pagination>
            </el-col>

        </template>
      </BaseContainer>
</template>
<script>
import axios from 'axios'
import { API__code, API_Urls,API_Common,imgURLs} from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  inject:['reload'],
  data(){
    return{
      id:'',
      checkCode:'',
      token:'',
      urlList:[],
      pageSize1: 20,
      total1:1,
      pageNumber1:1,
      listLoading:false,
      addUrl:{
        cloudserviceurl:'',
        version:'',
        comment:'',
      },
      addUrlRules:{
        cloudserviceurl: [
          { required: true, message: '请输入路径', trigger: 'blur' }
        ],
      },
      addUrlVisible:false,
      addUrlLoading:false,

      editUrlVisible:false,
      editUrlLoading:false,
      editUrl:{
        cloudserviceurl:'',
        version:'',
        comment:'',
      },
      editUrlRules:{
        cloudserviceurl: [
          { required: true, message: '请输入路径', trigger: 'blur' }
        ],
      },
    }
  },

  components: {
    BaseContainer
  },

  methods:{
    editUrlSubmit:function(){
      if(!this.editUrl.cloudserviceurl){
        this.$message.error("路径地址不可为空！");
        return;
      }
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        mode:'',
        cloudserviceurl:this.editUrl.cloudserviceurl,
        version:this.editUrl.version,
        comment:this.editUrl.comment,
        id:this.editUrl.id,
      }
      this.editUrlLoading = true;
      API_Urls.upUrls(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.editUrlVisible = false;
          this.getUrls();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editUrlLoading = false;
      }).catch(err =>{
        this.editUrlLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    addUrlSubmit:function(){
      if(!this.addUrl.cloudserviceurl){
        this.$message.error("路径地址不可为空！");
        return;
      }
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        mode:'save',
        cloudserviceurl:this.addUrl.cloudserviceurl,
        version:this.addUrl.version,
        comment:this.addUrl.comment,
      }
      this.addUrlLoading = true;
      API_Urls.upUrls(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.addUrlVisible = false;
          this.getUrls();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.addUrlLoading = false;
      }).catch(err =>{
        this.addUrlLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    handleURLAdd:function(){
      this.addUrlVisible = true;
      this.addUrl = {};
    },
    handleURLEdit:function(index,row){
      this.editUrlVisible = true;
      this.editUrl = Object.assign({}, row);
    },
    handleURLDel:function(index,row){
      let _this = this;
      this.$confirm('确认删除该用户吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
        }
        API_Urls.delUrls(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getUrls();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    handleCurrentChange1(val) {
      this.pageNumber1 = val;
      this.getUrls();
    },
    handleSizeChange1(val) {
			this.pageSize1 = val;
			this.getUrls();
		},
    getUrls:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:this.pageNumber1,
        pageSize:this.pageSize1,
      }
      API_Urls.getUrlsList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.urlList = res.data.data.list;
          this.total1 = res.data.data.totalRow;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
              this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
              this.id = arr2[1];
          }
        }
      }
    },
  },
  created(){
    this.getCookie();
  },
  mounted(){
    this.getUrls();
  }
}
</script>
<style lang="scss">
.dnnCloud-UrlsNumber-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style>
.el-tabs__nav-scroll {
    padding:0;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

</style>


// WEBPACK FOOTER //
// UrlsNumber.vue?535096c8